module.exports = __webpack_public_path__ + "static/img/phone_ico_wechat.bba1b2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/big_picture/phone_ico_wechat.png
// module id = aohJ
// module chunks = 0